<template>
  <v-card outlined class="mt-4 hph-wrapper">
    <!-- Encabezado -->
    <v-card-title class="d-flex align-center py-3">
      <div>
        <!--<div class="subtitle-2 font-weight-bold">
          Datos crudos Hora por Hora (tal como los manda el EP)
        </div>-->
        <div class="caption grey--text text--darken-1">
          {{ nombreMaquina || 'Máquina' }}
          <span v-if="chartCategories.length">
            · {{ chartCategories[0] }} → {{ chartCategories[chartCategories.length - 1] }}
          </span>
          <span v-if="rows.length">
            · {{ rows.length }} bloque(s) de hora
          </span>
        </div>
      </div>

      <v-spacer />

      <v-chip
        small
        v-if="chartHasData"
        color="blue lighten-5"
        text-color="blue darken-2"
        class="mr-2"
      >
        {{ oeePorTurnoRows.length }} registro(s) de turno
      </v-chip>
    </v-card-title>

    <v-divider />

    <v-card-text>
      <!-- 🔹 KPIs del rango (Disponibilidad, Rendimiento, Calidad, OEE) -->
      <div v-if="chartHasData" class="mb-4">
        <div class="caption grey--text text--darken-1 mb-1">
          KPIs promedio ponderados de los turnos en el rango
        </div>

        <v-row dense>
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center hph-kpi-card">
              <div class="d-flex justify-center align-center mb-1">
                <v-icon small class="mr-1" color="blue darken-2">
                  mdi-clock-check-outline
                </v-icon>
                <span class="caption grey--text text--darken-1 text-uppercase">
                  Disponibilidad
                </span>
              </div>
              <div class="headline font-weight-bold">
                {{ pf(kpisTurnos.disponibilidad) }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center hph-kpi-card">
              <div class="d-flex justify-center align-center mb-1">
                <v-icon small class="mr-1" color="indigo darken-2">
                  mdi-speedometer
                </v-icon>
                <span class="caption grey--text text--darken-1 text-uppercase">
                  Eficiencia
                </span>
              </div>
              <div class="headline font-weight-bold">
                {{ pf(kpisTurnos.rendimiento) }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center hph-kpi-card">
              <div class="d-flex justify-center align-center mb-1">
                <v-icon small class="mr-1" color="green darken-2">
                  mdi-check-decagram
                </v-icon>
                <span class="caption grey--text text--darken-1 text-uppercase">
                  Calidad
                </span>
              </div>
              <div class="headline font-weight-bold">
                {{ pf(kpisTurnos.calidad) }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center hph-kpi-card">
              <div class="d-flex justify-center align-center mb-1">
                <v-icon small class="mr-1" color="teal darken-2">
                  mdi-chart-areaspline
                </v-icon>
                <span class="caption grey--text text--darken-1 text-uppercase">
                  OEE
                </span>
              </div>
              <div class="headline font-weight-bold">
                {{ pf(kpisTurnos.oee) }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- 🔹 Gráfica por turno (barras) + OEE total (línea) -->
      <div v-if="chartHasData" class="mb-6">
        <VueApexCharts
          type="bar"
          height="460"
          :options="chartOptions"
          :series="chartSeries"
        />
      </div>

      <!-- 🔹 Heatmap + OEE por máquina en un layout tipo dashboard -->
      <v-row
        v-if="oeeHeatmapItems.length || oeeMaquinasItems.length"
        dense
        class="mb-4"
      >
        <!-- Heatmap OEE por día -->
        <v-col cols="12" md="6" v-if="oeeHeatmapItems.length">
          <div class="d-flex align-center mb-2">
            <div class="text-subtitle-2 font-weight-medium">
              OEE por día (promedio de turnos)
            </div>
            <v-spacer />
            <v-chip small color="grey lighten-4" text-color="grey darken-2">
              {{ oeeHeatmapHeadersFecha.length }} día(s)
            </v-chip>
          </div>

          <div style="overflow-x:auto">
            <v-simple-table dense class="oee-heatmap-table elevation-1">
              <thead>
                <tr>
                  <th class="text-left">Máquina</th>
                  <th
                    v-for="h in oeeHeatmapHeadersFecha"
                    :key="h.key"
                    class="text-center"
                  >
                    {{ h.label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in oeeHeatmapItems" :key="row.maquina">
                  <td class="font-weight-medium">
                    {{ row.maquina }}
                  </td>

                  <td
                    v-for="h in oeeHeatmapHeadersFecha"
                    :key="row.maquina + '-' + h.key"
                    class="pa-0 text-center"
                  >
                    <div
                      class="oee-heatmap-cell"
                      :style="estiloCeldaOee(row[h.key])"
                    >
                      <span v-if="row[h.key] != null">
                        {{ pf(row[h.key]) }}
                      </span>
                      <span v-else>
                        –
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-col>

        <!-- OEE promedio por máquina -->
        <v-col cols="12" md="6" v-if="oeeMaquinasItems.length">
          <div class="d-flex align-center mb-2">
            <div class="text-subtitle-2 font-weight-medium">
              OEE promedio por máquina
            </div>
            <v-spacer />
            <v-chip small color="blue lighten-5" text-color="blue darken-2">
              {{ oeeMaquinasItems.length }} máquina(s)
            </v-chip>
          </div>

          <VueApexCharts
            type="bar"
            :height="60 + oeeMaquinasItems.length * 50"
            :options="oeeMaquinasChartOptions"
            :series="oeeMaquinasChartSeries"
          />
        </v-col>
      </v-row>

      <!-- 🔹 Tabla cruda hora x hora (OCULTA por defecto, sólo para diagnóstico) -->
      <div v-if="rows.length">
        <div class="d-flex align-center justify-end mb-1">
          <v-btn
            small
            text
            color="primary"
            @click="showRawTable = !showRawTable"
          >
            <v-icon left small>
              {{ showRawTable ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
            </v-icon>
            {{ showRawTable ? 'Ocultar detalle hora x hora' : 'Ver detalle crudo (diagnóstico)' }}
          </v-btn>
        </div>

        <v-expand-transition>
          <div v-if="showRawTable">
            <div class="d-flex align-center mb-2">
              <div class="text-subtitle-2 font-weight-medium">
                Detalle hora x hora
              </div>
              <v-spacer />
              <v-chip small color="grey lighten-4" text-color="grey darken-2">
                Uso interno / diagnóstico
              </v-chip>
            </div>

            <v-data-table
              :headers="headers"
              :items="rows"
              dense
              disable-pagination
              hide-default-footer
              class="elevation-1"
              :item-class="rowClass"
              no-data-text="No hay datos disponibles"
            >
              <template v-slot:item.fecha="{ item }">
                <span class="caption grey--text text--darken-1">
                  {{ item.fecha }}
                </span>
              </template>

              <template v-slot:item.desdeHora="{ item }">
                <span :class="item.esCambioTurno ? 'hph-celda-turno' : ''">
                  {{ item.desdeHora }}
                </span>
              </template>

              <template v-slot:item.hastaHora="{ item }">
                <span :class="item.esCambioTurno ? 'hph-celda-turno' : ''">
                  {{ item.hastaHora }}
                </span>
              </template>

              <template v-slot:item.pasadoOEnCurso="{ item }">
                <v-chip
                  small
                  :color="item.pasadoOEnCurso ? 'green lighten-4' : 'grey lighten-3'"
                >
                  <span
                    :class="
                      item.pasadoOEnCurso
                        ? 'green--text text--darken-2'
                        : 'grey--text text--darken-1'
                    "
                  >
                    {{ item.pasadoOEnCurso ? 'Sí' : 'No' }}
                  </span>
                </v-chip>
              </template>
            </v-data-table>
          </div>
        </v-expand-transition>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'HoraPorHoraTablaRaw',
  components: {
    VueApexCharts
  },
  // v-model="ep" -> value/input
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    // EP HoraPorHora u arreglo de EPs
    value: {
      type: [Object, Array],
      default: () => ({})
    },
    // Ej: ['06:00', '18:00'] para marcar inicio/fin de turno
    horasCambioTurno: {
      type: Array,
      default: () => []
    },
    // Rango explícito para forzar días en la gráfica / heatmap
    fechaInicio: {
      type: String,
      default: null // 'YYYY-MM-DD'
    },
    fechaFin: {
      type: String,
      default: null // 'YYYY-MM-DD'
    }
  },
  data () {
    return {
      showRawTable: false
    }
  },
  computed: {
    // ================================
    //   INFO BÁSICA / NORMALIZACIONES
    // ================================
    nombreMaquina () {
      const src = this.value || {}
      const r = src.resumen || src.Resumen || {}

      // 🔹 Detectar multi-máquina por el detalle
      const detalle = src.oeePorTurnoDetalle || src.OeePorTurnoDetalle
      if (Array.isArray(detalle)) {
        const maquinas = Array.from(
          new Set(
            detalle
              .map(d => d.maquinaNombre || d.MaquinaNombre || d.maquina || d.Maquina)
              .filter(Boolean)
          )
        )
        if (maquinas.length > 1) return 'Varias máquinas'
        if (maquinas.length === 1) return maquinas[0]
      }

      return (
        r.nombreMaquina ||
        r.NombreMaquina ||
        (this.rows[0] && this.rows[0].maquinaNombre) ||
        ''
      )
    },

    // Normaliza la respuesta hora x hora del EP
    rows () {
      const src = this.value || {}
      let horas = []

      if (Array.isArray(src)) {
        horas = src
      } else if (Array.isArray(src.horaPorHora)) {
        horas = src.horaPorHora
      } else if (Array.isArray(src.HoraPorHora)) {
        horas = src.HoraPorHora
      } else if (Array.isArray(src.horas)) {
        horas = src.horas
      } else if (Array.isArray(src.Horas)) {
        horas = src.Horas
      } else {
        const values = Object.values(src)
        const found = values.find(
          v =>
            Array.isArray(v) &&
            v.length &&
            typeof v[0] === 'object' &&
            ('desdeHora' in v[0] || 'hastaHora' in v[0])
        )
        if (found) horas = found
      }

      if (!Array.isArray(horas)) horas = []

      return horas.map(h => {
        const resumen = h.resumen || h.Resumen || {}
        const acum = resumen.acumulado || resumen.Acumulado || null
        const hor = resumen.hora || resumen.Hora || null

        const dispAcum = acum?.disponibilidad ?? acum?.Disponibilidad
        const rendAcum =
          (acum?.rendimiento ?? acum?.Rendimiento) ??
          (acum?.eficiencia ?? acum?.Eficiencia)
        const caliAcum = acum?.calidad ?? acum?.Calidad
        const oeeAcum = acum?.oee ?? acum?.OEE
        const oeeHora = hor?.oee ?? hor?.OEE

        const cavs = h.cavidades || h.Cavidades || []

        const esperadasTot =
          h.esperadas ??
          h.Esperadas ??
          cavs.reduce(
            (s, c) => s + (c.esperadas ?? c.Esperadas ?? 0),
            0
          )

        const okTot =
          h.ok ??
          h.Ok ??
          cavs.reduce(
            (s, c) => s + (c.ok ?? c.Ok ?? 0),
            0
          )

        const noOkTot =
          h.noOk ??
          h.NoOk ??
          cavs.reduce(
            (s, c) => s + (c.noOk ?? c.NoOk ?? 0),
            0
          )

        const teoricaTot =
          h.cantidadEsperadaTeorica ??
          h.CantidadEsperadaTeorica ??
          cavs.reduce(
            (s, c) =>
              s +
              (c.cantidadEsperadaTeorica ??
                c.CantidadEsperadaTeorica ??
                0),
            0
          )

        const rateTot =
          h.rate ??
          h.Rate ??
          cavs.reduce(
            (s, c) => s + (c.rate ?? c.Rate ?? 0),
            0
          )

        const desdeHora = h.desdeHora || h.DesdeHora || null
        const hastaHora = h.hastaHora || h.HastaHora || null

        // Día lógico del turno (para turno nocturno)
        const turnoDesdeRaw = h.turnoDesde || h.TurnoDesde || null
        const diaTurno =
          this.normalizarFechaTurno(turnoDesdeRaw) ||
          h.fecha ||
          h.Fecha ||
          null

        const row = {
          fecha: h.fecha || h.Fecha || null,
          maquinaNombre:
            h.maquinaNombre || h.maquina || h.Maquina || null,
          desdeHora,
          hastaHora,

          esperadas: Math.round(esperadasTot || 0),
          cantidadEsperadaTeorica: Math.round(teoricaTot || 0),
          rate: Math.round(rateTot || 0),
          ok: Math.round(okTot || 0),
          noOk: Math.round(noOkTot || 0),

          oee: oeeAcum ?? h.oee ?? h.Oee ?? null,
          oeeHora: oeeHora ?? h.oee ?? h.Oee ?? null,
          disponibilidad:
            dispAcum ?? h.disponibilidad ?? h.Disponibilidad ?? null,
          eficiencia:
            rendAcum ?? h.eficiencia ?? h.Eficiencia ?? null,
          calidad: caliAcum ?? h.calidad ?? h.Calidad ?? null,

          segundosParo: h.segundosParo ?? h.tiempoParoSeg ?? null,
          segundosParoProgramado:
            h.segundosParoProgramado ??
            h.tiempoParoProgramadoSeg ??
            null,
          segundosParoNoProgramado:
            h.segundosParoNoProgramado ??
            h.tiempoParoNoProgramadoSeg ??
            null,
          segundosInactividadDisponible:
            h.segundosInactividadDisponible ??
            h.tiempoInactividadDisponibleSeg ??
            null,
          pasadoOEnCurso: !!h.pasadoOEnCurso,

          turno:
            h.turnoNombre ||
            h.TurnoNombre ||
            this.calcularTurnoPorHora(desdeHora),
          diaTurno,
          turnoDesde: turnoDesdeRaw
        }

        row.esCambioTurno = this.esInicioFinTurno(row)

        return row
      })
    },

    headers () {
      return [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Máquina', value: 'maquinaNombre' },
        { text: 'Turno', value: 'turno' },
        { text: 'Desde', value: 'desdeHora' },
        { text: 'Hasta', value: 'hastaHora' },
        { text: 'Esperadas', value: 'esperadas' },
        { text: 'Cant. Esperada Teórica', value: 'cantidadEsperadaTeorica' },
        { text: 'Rate', value: 'rate' },
        { text: 'OK', value: 'ok' },
        { text: 'No OK', value: 'noOk' },
        { text: 'OEE (acum.)', value: 'oee' },
        { text: 'OEE (hora.)', value: 'oeeHora' },
        { text: 'Disponibilidad (acum.)', value: 'disponibilidad' },
        { text: 'Eficiencia (acum.)', value: 'eficiencia' },
        { text: 'Calidad (acum.)', value: 'calidad' },
        { text: 'Seg. Paro', value: 'segundosParo' },
        { text: 'Seg. Paro Prog.', value: 'segundosParoProgramado' },
        { text: 'Seg. Paro No Prog.', value: 'segundosParoNoProgramado' },
        {
          text: 'Seg. Inactividad Disp.',
          value: 'segundosInactividadDisponible'
        },
        { text: 'Pasado / En curso', value: 'pasadoOEnCurso' }
      ]
    },

    // ================================
    //           OEE POR TURNO
    // ================================
    oeePorTurnoRows () {
      const src = this.value || {}
      let arr = []

      if (Array.isArray(src.oeePorTurno)) arr = src.oeePorTurno
      else if (Array.isArray(src.OeePorTurno)) arr = src.OeePorTurno
      else if (Array.isArray(src.oee_por_turno)) arr = src.oee_por_turno

      if (!Array.isArray(arr)) return []

      return arr.map(r => {
        const disp = r.disponibilidad ?? r.Disponibilidad
        const rend =
          r.rendimiento ??
          r.Rendimiento ??
          r.eficiencia ??
          r.Eficiencia
        const cal = r.calidad ?? r.Calidad
        const oee = r.oee ?? r.Oee ?? r.OEE

        return {
          fecha: r.fecha || r.Fecha || null,
          turnoId: r.turnoId ?? r.TurnoId ?? null,
          turnoNombre: r.turnoNombre || r.TurnoNombre || null,
          desde: r.desde || r.Desde || null,
          hasta: r.hasta || r.Hasta || null,
          disponibilidad: isFinite(Number(disp)) ? Number(disp) : 0,
          rendimiento: isFinite(Number(rend)) ? Number(rend) : 0,
          calidad: isFinite(Number(cal)) ? Number(cal) : 0,
          oee: isFinite(Number(oee)) ? Number(oee) : 0
        }
      })
    },
    oeePorTurnoDetalleRows () {
  const src = this.value || {}
  let arr = []

  if (Array.isArray(src.oeePorTurnoDetalle)) arr = src.oeePorTurnoDetalle
  else if (Array.isArray(src.OeePorTurnoDetalle)) arr = src.OeePorTurnoDetalle

  if (!Array.isArray(arr) || !arr.length) return []

  return arr
    .map(r => {
      const disp = r.disponibilidad ?? r.Disponibilidad
      const rend =
        r.rendimiento ??
        r.Rendimiento ??
        r.eficiencia ??
        r.Eficiencia
      const cal = r.calidad ?? r.Calidad
      const oee = r.oee ?? r.Oee ?? r.OEE

      return {
        fecha: r.fecha || r.Fecha || null,
        turnoId: r.turnoId ?? r.TurnoId ?? null,
        turnoNombre: r.turnoNombre || r.TurnoNombre || null,
        maquinaNombre:
          r.maquinaNombre ||
          r.MaquinaNombre ||
          r.maquina ||
          r.Maquina ||
          null,
        disponibilidad: isFinite(Number(disp)) ? Number(disp) : 0,
        rendimiento: isFinite(Number(rend)) ? Number(rend) : 0,
        calidad: isFinite(Number(cal)) ? Number(cal) : 0,
        oee: isFinite(Number(oee)) ? Number(oee) : 0
      }
    })
    .filter(r => r.maquinaNombre && r.fecha)
},

    resumenGlobal () {
      const src = this.value || {}
      const r = src.resumen || src.Resumen
      if (!r) return null

      const disp =
        r.disponibilidadPromedio ??
        r.DisponibilidadPromedio ??
        r.disponibilidad ??
        r.Disponibilidad

      const rend =
        r.eficienciaPromedio ??
        r.EficienciaPromedio ??
        r.rendimientoPromedio ??
        r.RendimientoPromedio ??
        r.rendimiento ??
        r.Rendimiento

      const cal =
        r.calidadPromedio ??
        r.CalidadPromedio ??
        r.calidad ??
        r.Calidad

      const oee =
        r.oeePromedio ??
        r.OeePromedio ??
        r.oee ??
        r.OEE

      return {
        disponibilidad: Number(disp) || 0,
        rendimiento: Number(rend) || 0,
        calidad: Number(cal) || 0,
        oee: Number(oee) || 0
      }
    },

    kpisTurnos () {
      const turnos = this.oeePorTurnoRows || []

      // 1) Base: sólo filas con turno
      let base = turnos.filter(r => r.turnoNombre || r.turnoId)
      if (!base.length) {
        base = turnos
      }

      let raw = null

      if (base.length) {
        let sumDisp = 0
        let sumRend = 0
        let sumCal = 0
        let sumOee = 0
        let n = 0

        base.forEach(r => {
          const disp = Number(r.disponibilidad || 0)
          const rend = Number(r.rendimiento || 0)
          const cal = Number(r.calidad || 0)
          const oee = Number(r.oee || 0)

          const allZero = disp === 0 && rend === 0 && cal === 0 && oee === 0
          if (allZero) return

          sumDisp += disp
          sumRend += rend
          sumCal += cal
          sumOee += oee
          n++
        })

        if (n > 0) {
          raw = {
            disponibilidad: sumDisp / n,
            rendimiento: sumRend / n,
            calidad: sumCal / n,
            oee: sumOee / n
          }
        }
      }

      // Fallback: resumen del EP
      if (!raw && this.resumenGlobal) {
        raw = this.resumenGlobal
      }

      if (!raw) {
        return {
          disponibilidad: 0,
          rendimiento: 0,
          calidad: 0,
          oee: 0
        }
      }

      // 2) Normalizar factores a 0–100
      let disp = Math.max(0, Math.min(100, Number(raw.disponibilidad) || 0))
      let rend = Math.max(0, Math.min(100, Number(raw.rendimiento) || 0))
      let cal = Math.max(0, Math.min(100, Number(raw.calidad) || 0))

      let oeeTarget = Number(raw.oee)
      if (!isFinite(oeeTarget) || oeeTarget <= 0) {
        const derived = (disp * rend * cal) / 10000
        oeeTarget = isFinite(derived) ? derived : 0
      }

      const oeeDesdeFactores = (disp * rend * cal) / 10000

      if (
        !oeeDesdeFactores ||
        !isFinite(oeeDesdeFactores) ||
        !isFinite(oeeTarget) ||
        oeeTarget <= 0
      ) {
        return {
          disponibilidad: Number(disp.toFixed(2)),
          rendimiento: Number(rend.toFixed(2)),
          calidad: Number(cal.toFixed(2)),
          oee: Number(oeeTarget.toFixed(2))
        }
      }

      const ratio = oeeTarget / oeeDesdeFactores
      if (!isFinite(ratio) || ratio <= 0) {
        return {
          disponibilidad: Number(disp.toFixed(2)),
          rendimiento: Number(rend.toFixed(2)),
          calidad: Number(cal.toFixed(2)),
          oee: Number(oeeTarget.toFixed(2))
        }
      }

      const k = Math.cbrt(ratio)
      const clamp = v => Math.max(0, Math.min(100, v))

      const dispAdj = clamp(disp * k)
      const rendAdj = clamp(rend * k)
      const calAdj = clamp(cal * k)

      return {
        disponibilidad: Number(dispAdj.toFixed(2)),
        rendimiento: Number(rendAdj.toFixed(2)),
        calidad: Number(calAdj.toFixed(2)),
        oee: Number(oeeTarget.toFixed(2))
      }
    },

    // ================================
    //     ESTRUCTURA PARA GRÁFICA
    // ================================
    chartBaseRows () {
      return this.oeePorTurnoRows || []
    },

    chartHasData () {
      return (this.oeePorTurnoRows || []).length > 0
    },

    chartStructure () {
      const rows = this.chartBaseRows
      if (!rows.length) {
        return { fechas: [], turnos: [], map: {} }
      }

      const map = {}
      const fechasSet = new Set()
      const turnosSet = new Set()

      rows.forEach(r => {
        const fecha = r.fecha
        const tieneTurno = !!(r.turnoNombre || r.turnoId)
        const turno = r.turnoNombre || (r.turnoId ? `TURNO ${r.turnoId}` : null)
        const oee = Number(r.oee) || 0

        if (!fecha) return
        fechasSet.add(fecha)

        if (!map[fecha]) {
          map[fecha] = {
            turnos: {},
            acumuladoOee: null
          }
        }

        if (tieneTurno && turno) {
          turnosSet.add(turno)
          map[fecha].turnos[turno] = { oee }
        } else {
          map[fecha].acumuladoOee = oee
        }
      })

      const fechas = Array.from(fechasSet).sort((a, b) => a.localeCompare(b))
      const turnos = Array.from(turnosSet)

      return { fechas, turnos, map }
    },

    chartCategories () {
      // 1) Usar rango explícito si llega
      const rango = this.generarRangoFechas()
      if (rango && rango.length) {
        return rango
      }

      // 2) Fallback: sólo fechas que trae el EP
      const rows = this.oeePorTurnoRows || []
      const fechasSet = new Set(
        rows
          .map(r => r.fecha)
          .filter(f => !!f)
      )

      return Array.from(fechasSet).sort((a, b) => a.localeCompare(b))
    },

    chartSeries () {
      const rowsTurnos = this.oeePorTurnoRows || []
      const fechas = this.chartCategories

      if (!fechas.length || !rowsTurnos.length) return []

      const series = []

      // Separamos filas con turno y sin turno
      const rowsConTurno = rowsTurnos.filter(r => r.turnoNombre || r.turnoId)
      const rowsSinTurno = rowsTurnos.filter(r => !r.turnoNombre && !r.turnoId)

      // 🔹 CASO 1: NO hay turnos, sólo totales por día -> solo línea
      if (!rowsConTurno.length && rowsSinTurno.length) {
        const totalData = fechas.map(fecha => {
          const r = rowsSinTurno.find(x => x.fecha === fecha)
          if (!r) return null // día del rango sin datos -> no punto

          const oee  = Number(r.oee || 0)
          const disp = Number(r.disponibilidad || 0)
          const rend = Number(r.rendimiento || 0)
          const cal  = Number(r.calidad || 0)

          const allZero = oee === 0 && disp === 0 && rend === 0 && cal === 0
          if (!isFinite(oee)) return null
          if (allZero) return 0 // si realmente todo está en 0, mostramos 0

          return Number(oee.toFixed(2))
        })

        if (totalData.some(v => v != null)) {
          series.push({
            name: 'OEE total',
            type: 'line',
            data: totalData
          })
        }

        return series
      }

      // 🔹 CASO 2: SÍ hay filas por turno -> barras + línea

      // Info por día desde filas de turno (para barras y fallback)
      const infoPorDia = {}

      fechas.forEach(fecha => {
        const delDia = rowsConTurno.filter(r => r.fecha === fecha)

        const allZero =
          delDia.length > 0 && delDia.every(r => this.esFilaTodoCero(r))

        const avgOee = this.calcularOeePromedioDia(delDia)

        infoPorDia[fecha] = {
          delDia,
          allZero,
          avgOee
        }
      })

      // Barras por turno (ocultando días en ceros o sin datos)
      const turnosUnicos = Array.from(
        new Set(
          rowsConTurno
            .map(r => r.turnoNombre || (r.turnoId ? `TURNO ${r.turnoId}` : null))
            .filter(Boolean)
        )
      )

      turnosUnicos.forEach(turnoLabel => {
        const data = fechas.map(fecha => {
          const info = infoPorDia[fecha]
          if (!info || !info.delDia.length || info.allZero) {
            return null // día sin datos o todo en ceros -> sin barra
          }

          const reg = info.delDia.find(
            r =>
              (r.turnoNombre ||
                (r.turnoId ? `TURNO ${r.turnoId}` : null)) === turnoLabel
          )

          if (!reg) return null
          return Number(reg.oee.toFixed(2))
        })

        series.push({
          name: turnoLabel,
          type: 'column',
          data
        })
      })

      // 🔹 Línea: OEE diario usando la MISMA matriz que la tabla (heatmap)
      const diarioHM = this.oeeDiarioDesdeHeatmap || {}

      const totalData = fechas.map(fecha => {
        let val = diarioHM[fecha]

        // Si el heatmap no trae valor (casos viejos / fallback),
        // usamos el cálculo anterior por turnos para no romper nada.
        if (val == null || !isFinite(val)) {
          const info = infoPorDia[fecha]

          // Día dentro del rango pero sin turnos -> sin punto
          if (!info || !info.delDia.length) {
            return null
          }

          // Si solo hubo filas "vacías", mostramos 0
          if (info.allZero) {
            return 0
          }

          const avg = info.avgOee
          if (avg == null || !isFinite(avg)) {
            return null
          }

          val = avg
        }

        return Number(val.toFixed(2))
      })

      const nonNullPoints = totalData.filter(v => v != null)

      if (nonNullPoints.length >= 2) {
        series.push({
          name: 'OEE total',
          type: 'line',
          data: totalData
        })
      }

      return series
    },

    yAxisBounds () {
      const series = this.chartSeries || []
      const vals = []

      series.forEach(s => {
        ;(s.data || []).forEach(v => {
          if (v != null && isFinite(v)) vals.push(Number(v))
        })
      })

      if (!vals.length) {
        return { min: 0, max: 100 }
      }

      const minVal = Math.min(...vals)
      const maxVal = Math.max(...vals)

      const min = Math.max(0, Math.floor(minVal - 5))
      const max = Math.min(100, Math.ceil(maxVal + 5))

      return { min, max }
    },

    chartOptions () {
      return {
        chart: {
          type: 'bar',
          stacked: false,
          toolbar: { show: true }
        },
        plotOptions: {
          bar: {
            columnWidth: '35%',
            endingShape: 'flat'
          }
        },
        dataLabels: {
          enabled: true,
          formatter: val => (val == null ? '' : `${val}%`),
          offsetY: -14,
          style: {
            fontSize: '23px',
            fontWeight: 'bold',
            colors: ['#000']
          },
          background: {
            enabled: false,
          }
        },
        stroke: {
          show: true,
          width: 2
        },
        markers: {
          size: 4
        },
        xaxis: {
          categories: this.chartCategories,
          title: { text: 'Fecha' }
        },
        yaxis: {
          title: { text: 'OEE (%)' },
          min: this.yAxisBounds.min,
          max: this.yAxisBounds.max
        },
        legend: {
          position: 'top'
        },
        tooltip: {
          y: {
            formatter: val =>
              val == null ? '' : `${val.toFixed(2)}%`
          }
        }
      }
    },

    // ================================
    //        HEATMAP POR DÍA
    // ================================
    oeeHeatmapHeadersFecha () {
      const fechas = this.chartCategories || []
      return fechas.map(f => ({
        key: f,
        label: this.formatearFechaCorta(f)
      }))
    },

        oeeHeatmapItems () {
      const fechas = this.chartCategories || []
      if (!fechas.length) return []

      const detalle = this.oeePorTurnoDetalleRows || []
      let rowsTurnos = this.oeePorTurnoRows || []

      // Si no hay oeePorTurno pero sí detalle, usamos detalle como base
      if (!rowsTurnos.length && detalle.length) {
        rowsTurnos = detalle
      }

      // ================================
      //   ¿Cuántas máquinas tengo?
      // ================================
      const maquinas = Array.from(
        new Set(detalle.map(r => r.maquinaNombre).filter(Boolean))
      )

      // ================================
      //   1) MODO MULTI-MÁQUINA REAL
      //      (solo si hay > 1 máquina)
      // ================================
      if (maquinas.length > 1) {
        const items = []

        maquinas.forEach(m => {
          // Filas de esta máquina y SOLO por turno
          const rowsM = detalle.filter(
            r =>
              r.maquinaNombre === m &&
              (r.turnoNombre || r.turnoId)
          )

          const row = { maquina: m }

          fechas.forEach(fecha => {
            const delDia = rowsM.filter(r => r.fecha === fecha)
            const oeeDia = this.calcularOeePromedioDia(delDia)
            row[fecha] = oeeDia
          })

          items.push(row)
        })

        return items
      }

      // ================================
      //   2) MODO UNA SOLA MÁQUINA
      //      (lo de tu screenshot)
      //      -> MISMO dataset que la gráfica
      // ================================
      if (!rowsTurnos.length) return []

      // Usamos las mismas filas que la gráfica: solo con turno
      const rowsConTurno = rowsTurnos.filter(r => r.turnoNombre || r.turnoId)

      const maquina = this.nombreMaquina || 'Máquina'
      const row = { maquina }

      fechas.forEach(fecha => {
        const delDia = rowsConTurno.filter(r => r.fecha === fecha)
        const oeeDia = this.calcularOeePromedioDia(delDia)
        row[fecha] = oeeDia
      })

      return [row]
    },

    // ================================
    //      OEE PROMEDIO POR MÁQUINA
    // ================================
    oeeMaquinasItems () {
      const src = this.value || {}
      const detalle = this.oeePorTurnoDetalleRows || []
      const items = []

      // ================================
      // 1) MODO MULTI-MÁQUINA (HoraPorHoraRango nuevo)
      //    Solo si hay MÁS DE UNA máquina en el detalle
      // ================================
      if (!Array.isArray(src) && detalle.length) {
        const maquinas = Array.from(
          new Set(detalle.map(r => r.maquinaNombre).filter(Boolean))
        )

        if (maquinas.length > 1) {
          const porMaquina = new Map()

          detalle.forEach(r => {
            if (!r.maquinaNombre || !r.fecha) return
            if (!porMaquina.has(r.maquinaNombre)) {
              porMaquina.set(r.maquinaNombre, [])
            }
            porMaquina.get(r.maquinaNombre).push(r)
          })

          porMaquina.forEach((rows, maquina) => {
            const porFecha = {}

            rows.forEach(r => {
              if (!porFecha[r.fecha]) porFecha[r.fecha] = []
              porFecha[r.fecha].push(r)
            })

            const oeesPorDia = []

            Object.keys(porFecha).forEach(fecha => {
              const delDia = porFecha[fecha]
              const sum = delDia.reduce(
                (acc, r) => acc + Number(r.oee || 0),
                0
              )
              const avg = delDia.length ? sum / delDia.length : null

              if (avg != null && isFinite(avg)) {
                oeesPorDia.push(avg)
              }
            })

            if (!oeesPorDia.length) return

            const sumDias = oeesPorDia.reduce((a, b) => a + b, 0)
            const avgMaq = sumDias / oeesPorDia.length

            items.push({
              maquina,
              oee: Number(avgMaq.toFixed(2))
            })
          })

          // multi-máquina: regresamos aquí
          return items.sort((a, b) => a.oee - b.oee)
        }
        // si solo hay UNA máquina en el detalle, caemos a la lógica de abajo (modo 1 máquina)
      }

      // ================================
      // 2) Helper para modos antiguos / fallback
      // ================================
      const calcularOeeMaquinaDesdeTurnos = ep => {
        if (!ep) return null

        let arr = []
        if (Array.isArray(ep.oeePorTurno)) arr = ep.oeePorTurno
        else if (Array.isArray(ep.OeePorTurno)) arr = ep.OeePorTurno
        else if (Array.isArray(ep.oee_por_turno)) arr = ep.oee_por_turno

        let rows = []
        if (Array.isArray(arr)) {
          rows = arr.map(r => {
            const disp = r.disponibilidad ?? r.Disponibilidad
            const rend =
              r.rendimiento ??
              r.Rendimiento ??
              r.eficiencia ??
              r.Eficiencia
            const cal = r.calidad ?? r.Calidad
            const oee = r.oee ?? r.Oee ?? r.OEE

            return {
              fecha: r.fecha || r.Fecha || null,
              turnoId: r.turnoId ?? r.TurnoId ?? null,
              turnoNombre: r.turnoNombre || r.TurnoNombre || null,
              disponibilidad: isFinite(Number(disp)) ? Number(disp) : 0,
              rendimiento: isFinite(Number(rend)) ? Number(rend) : 0,
              calidad: isFinite(Number(cal)) ? Number(cal) : 0,
              oee: isFinite(Number(oee)) ? Number(oee) : 0
            }
          })
        }

        if (!rows.length) {
          const r = ep.resumen || ep.Resumen || {}
          const raw =
            r.oeePromedio ??
            r.OeePromedio ??
            r.oee ??
            r.OEE
          const n = Number(raw)
          return isFinite(n) ? Number(n.toFixed(2)) : null
        }

        const fechas = Array.from(
          new Set(rows.map(x => x.fecha).filter(Boolean))
        ).sort((a, b) => a.localeCompare(b))

        const oeesPorDia = []

        fechas.forEach(fecha => {
          const delDia = rows.filter(r => {
            const tieneTurno = !!(r.turnoNombre || r.turnoId)
            return r.fecha === fecha && tieneTurno
          })

          if (!delDia.length) return

          const sum = delDia.reduce(
            (acc, r) => acc + Number(r.oee || 0),
            0
          )
          const avg = sum / delDia.length

          if (isFinite(avg)) {
            oeesPorDia.push(avg)
          }
        })

        if (!oeesPorDia.length) return null

        const sumDias = oeesPorDia.reduce((a, b) => a + b, 0)
        const avgMaquina = sumDias / oeesPorDia.length
        return Number(avgMaquina.toFixed(2))
      }

      // ================================
      // 3) MODO ARRAY DE EPs (multi-máquina viejo)
      // ================================
      if (Array.isArray(src)) {
        src.forEach(ep => {
          if (!ep) return

          const r = ep.resumen || ep.Resumen || {}
          const nombre =
            r.nombreMaquina ||
            r.NombreMaquina ||
            ep.maquinaNombre ||
            ep.Maquina ||
            'Máquina'

          const oeeMaquina = calcularOeeMaquinaDesdeTurnos(ep)
          if (oeeMaquina == null) return

          items.push({
            maquina: nombre,
            oee: oeeMaquina
          })
        })

        return items
      }

      // ================================
      // 4) MODO UNA SOLA MÁQUINA (EP único)
      //    → usamos el mismo OEE que el KPI de arriba
      // ================================
      const nombre = this.nombreMaquina || 'Máquina'

      const kpiOee = this.kpisTurnos && isFinite(this.kpisTurnos.oee)
        ? Number(this.kpisTurnos.oee.toFixed(2))
        : null

      if (kpiOee != null) {
        items.push({
          maquina: nombre,
          oee: kpiOee
        })
        return items
      }

      // Fallback por si por alguna razón no hay kpisTurnos
      const oeeMaquina = calcularOeeMaquinaDesdeTurnos(src)
      if (oeeMaquina != null) {
        items.push({
          maquina: nombre,
          oee: oeeMaquina
        })
      }

      return items
    },
    oeeDiarioDesdeHeatmap () {
      const items = this.oeeHeatmapItems || []
      const fechas = this.chartCategories || []
      const map = {}

      if (!fechas.length || !items.length) return map

      fechas.forEach(fecha => {
        let sum = 0
        let n = 0
        let hadZero = false

        items.forEach(row => {
          if (!row) return
          const raw = row[fecha]

          // sin dato
          if (raw == null || raw === '') return

          const v = Number(raw)
          if (!isFinite(v)) return

          if (v === 0) {
            // tratamos el 0 como "sin aporte", pero recordamos que hubo datos
            hadZero = true
            return
          }

          sum += v
          n++
        })

        if (n > 0) {
          map[fecha] = sum / n
        } else if (hadZero) {
          // hubo sólo ceros → OEE día = 0
          map[fecha] = 0
        } else {
          // sin datos reales
          map[fecha] = null
        }
      })

      return map
    }, 
    oeeMaquinasCategorias () {
      return this.oeeMaquinasItems.map(x => x.maquina)
    },

    oeeMaquinasValores () {
      return this.oeeMaquinasItems.map(x => x.oee)
    },

    oeeMaquinasChartSeries () {
      return [
        {
          name: 'OEE',
          data: this.oeeMaquinasValores
        }
      ]
    },

    oeeMaquinasChartOptions () {
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '60%',
            borderRadius: 4
          }
        },
        dataLabels: {
          enabled: true,
          formatter: val => (val == null ? '' : `${val}%`),
          style: {
            fontSize: '12px',
            fontWeight: 'bold'
          }
        },
        xaxis: {
          categories: this.oeeMaquinasCategorias,
          min: 0,
          max: 100,
          labels: {
            formatter: val => `${val}%`
          }
        },
        yaxis: {
          labels: {
            style: { fontWeight: 600 }
          }
        },
        tooltip: {
          y: {
            formatter: val =>
              val == null ? '' : `${val.toFixed(2)}%`
          }
        },
        colors: ['#26A69A']
      }
    }
  },

  methods: {
    // ================================
    //             UTILS
    // ================================
    esFilaTodoCero (r) {
      if (!r) return true
      const oee  = Number(r.oee || 0)
      const disp = Number(r.disponibilidad || 0)
      const rend = Number(r.rendimiento || 0)
      const cal  = Number(r.calidad || 0)
      return oee === 0 && disp === 0 && rend === 0 && cal === 0
    },
    // Promedio de OEE por día a partir de filas de turno,
    // ignorando filas completamente en cero.
    calcularOeePromedioDia (rows) {
      if (!Array.isArray(rows) || !rows.length) return null

      let sum = 0
      let n = 0
      let soloCeros = true

      rows.forEach(r => {
        if (!r) return

        const oee  = Number(r.oee || 0)
        const disp = Number(r.disponibilidad || 0)
        const rend = Number(r.rendimiento || 0)
        const cal  = Number(r.calidad || 0)

        const allZero = oee === 0 && disp === 0 && rend === 0 && cal === 0
        if (allZero) return

        soloCeros = false
        if (!isFinite(oee)) return

        sum += oee
        n++
      })

      // Si solo había filas en ceros, lo dejamos explícitamente en 0%
      if (soloCeros) return 0
      if (!n) return null

      const avg = sum / n
      return isFinite(avg) ? Number(avg.toFixed(2)) : null
    },
    formatearFechaCorta (f) {
      if (!f) return ''
      const parts = f.split('-')
      if (parts.length === 3) {
        const [yyyy, mm, dd] = parts
        return `${dd}/${mm}/${yyyy}`
      }
      return f
    },

    estiloCeldaOee (val) {
      if (val == null || !isFinite(val)) {
        return {
          backgroundColor: '#eeeeee',
          color: '#555',
          borderRadius: '4px'
        }
      }

      const v = Number(val)
      let bg = '#e53935'

      if (v >= 90) bg = '#2e7d32'
      else if (v >= 80) bg = '#43a047'
      else if (v >= 60) bg = '#fb8c00'
      else bg = '#e53935'

      return {
        backgroundColor: bg,
        color: '#fff',
        borderRadius: '4px'
      }
    },

    pf (val) {
      const n = Number(val || 0)
      if (!isFinite(n)) return '0.00%'
      return `${n.toFixed(2)}%`
    },

    generarRangoFechas () {
      if (!this.fechaInicio || !this.fechaFin) return null

      const out = []
      const d0 = new Date(this.fechaInicio + 'T00:00:00')
      const d1 = new Date(this.fechaFin + 'T00:00:00')

      if (isNaN(d0) || isNaN(d1) || d1 < d0) return null

      for (let d = new Date(d0); d <= d1; d.setDate(d.getDate() + 1)) {
        out.push(d.toISOString().slice(0, 10))
      }

      return out
    },

    // Turno 1: 06:00–18:00, Turno 2: 18:00–06:00 (fallback)
    calcularTurnoPorHora (horaStr) {
      if (!horaStr) return null
      const [hh] = horaStr.split(':').map(x => parseInt(x, 10))
      if (isNaN(hh)) return null
      if (hh >= 6 && hh < 18) return '1ER TURNO'
      return '2DO TURNO'
    },

    // Normaliza "turnoDesde" a "YYYY-MM-DD"
    normalizarFechaTurno (str) {
      if (!str) return null

      const iso = str.match(/(\d{4})-(\d{2})-(\d{2})/)
      if (iso) {
        const [, yyyy, mm, dd] = iso
        return `${yyyy}-${mm}-${dd}`
      }

      const mx = str.match(/(\d{2})\/(\d{2})\/(\d{4})/)
      if (mx) {
        const [, dd, mm, yyyy] = mx
        return `${yyyy}-${mm}-${dd}`
      }

      return str
    },

    esInicioFinTurno (row) {
      if (!this.horasCambioTurno || !this.horasCambioTurno.length) {
        return false
      }
      return (
        this.horasCambioTurno.includes(row.desdeHora) ||
        this.horasCambioTurno.includes(row.hastaHora)
      )
    },

    rowClass (item) {
      return item && item.esCambioTurno ? 'hph-cambio-turno' : ''
    }
  }
}
</script>

<style scoped>
.hph-wrapper {
  border-radius: 14px;
}

.hph-kpi-card {
  height: 100%;
}

/* Celdas de inicio / fin de turno */
.hph-celda-turno {
  background-color: #fff3e0;
  padding: 2px 4px;
  border-radius: 4px;
}

/* Fila completa de cambio de turno */
.hph-cambio-turno {
  background-color: #fffde7 !important;
}

/* Heatmap OEE por día */
.oee-heatmap-table th,
.oee-heatmap-table td {
  border-bottom: none !important;
}

.oee-heatmap-cell {
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
}
/* Números encima de las barras (dataLabels) más grandes */
::v-deep .apexcharts-data-labels text {
  font-size: 18px !important;   /* ajusta el tamaño que quieras */
  font-weight: 700 !important;
}
</style>
